// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qmgj","questions":"styles_questions__2jUqO","footer":"styles_footer__2Mftj"};